export const SET_TEMPLATE_ID = 'set_template_id';
export const SET_IS_CUSTOM_TEMPLATE_PUBLISHED =
  'set_is_custom_template_published';
